var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape8A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes_x5F_5a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M425.1,261.7c-16.6-3.2-34.6-2.2-48.3,9.1c-0.9,0.6-1.7,1.3-2.6,2c13.1,6.7,29.1,6.4,42.7,1 c1.6-0.7,3.1-1.5,4.5-2.3c3.6-2.2,6.8-5,9.3-8.6c-0.5-0.1-1-0.2-1.4-0.3C427.9,262.2,426.5,261.9,425.1,261.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3DBA3",
    d: "M425.1,261.7c1.4,0.3,2.8,0.5,4.2,0.9c0.5,0.1,1,0.2,1.4,0.3c-1.9-1.4-2.9-1.7-3.8-2.2 c-1.5-0.7-2.2-0.9-3.8-1.6c-19.2-7.7-36.5,0.4-48.8,13.7c0.8-0.7,1.7-1.4,2.6-2C390.5,259.5,408.5,258.5,425.1,261.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M413.4,260.2c-9.2-0.5-18.4,0.7-26.8,4.5c-0.2,1-0.3,2.1-0.3,3.1c0,3.7,1.4,7.1,3.7,9.7 c7.9,0.9,16.1,0,23.7-2.5c1.2-2.1,1.9-4.5,1.9-7.1C415.5,265,414.7,262.4,413.4,260.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M374.1,272.8C374.1,272.8,374.2,272.8,374.1,272.8C374.2,272.7,374.2,272.7,374.1,272.8L374.1,272.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C2515",
    d: "M420.6,260c-2.8-0.6-5.7-1.1-8.6-1.3c-12.8-1.1-28.3,3.6-37.9,14.1l0,0c0.8-0.7,1.7-1.4,2.6-2 c13.8-11.3,31.8-12.3,48.3-9.1c1.4,0.3,2.8,0.5,4.2,0.9c0.5,0.1,1,0.2,1.4,0.3c0-0.1,0.1-0.1,0.1-0.2 C427.4,261.7,424,260.7,420.6,260z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1A1212",
    cx: 400.9,
    cy: 267.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    fill: "#1A1212",
    enableBackground: "new    ",
    d: "M412.2,267.8c0-3-1.2-5.7-3-7.7c-6.3,0-12.6,0.9-18.5,2.9 c-0.7,1.4-1.1,3.1-1.1,4.8c0,4.4,2.5,8.1,6.1,10c4.2,0,8.4-0.4,12.5-1.4C410.6,274.4,412.2,271.3,412.2,267.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 407.2,
    cy: 265.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 397,
    cy: 272.7,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M289.1,261.7c16.6-3.2,34.6-2.2,48.3,9.1c0.9,0.6,1.7,1.3,2.6,2c-13.1,6.7-29.1,6.4-42.7,1 c-1.6-0.7-3.1-1.5-4.5-2.3c-3.6-2.2-6.8-5-9.3-8.6c0.5-0.1,1-0.2,1.4-0.3C286.4,262.2,287.7,261.9,289.1,261.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3DBA3",
    d: "M289.1,261.7c-1.4,0.3-2.8,0.5-4.2,0.9c-0.5,0.1-1,0.2-1.4,0.3c1.9-1.4,2.9-1.7,3.8-2.2 c1.5-0.7,2.2-0.9,3.8-1.6c19.2-7.7,36.5,0.4,48.8,13.7c-0.8-0.7-1.7-1.4-2.6-2C323.7,259.5,305.7,258.5,289.1,261.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M300.9,260.2c9.2-0.5,18.4,0.7,26.8,4.5c0.2,1,0.3,2.1,0.3,3.1c0,3.7-1.4,7.1-3.7,9.7 c-7.9,0.9-16.1,0-23.7-2.5c-1.2-2.1-1.9-4.5-1.9-7.1C298.7,265,299.5,262.4,300.9,260.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3C2515",
    d: "M293.6,260c2.8-0.6,5.7-1.1,8.6-1.3c12.8-1.1,28.3,3.6,37.9,14.1l0,0c-0.8-0.7-1.7-1.4-2.6-2 c-13.8-11.3-31.8-12.3-48.3-9.1c-1.4,0.3-2.8,0.5-4.2,0.9c-0.5,0.1-1,0.2-1.4,0.3c0-0.1-0.1-0.1-0.1-0.2 C286.8,261.7,290.2,260.7,293.6,260z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1A1212",
    cx: 313.3,
    cy: 267.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    fill: "#1A1212",
    enableBackground: "new    ",
    d: "M302.1,267.8c0-3,1.2-5.7,3-7.7c6.3,0,12.6,0.9,18.5,2.9 c0.7,1.4,1.1,3.1,1.1,4.8c0,4.4-2.5,8.1-6.1,10c-4.2,0-8.4-0.4-12.5-1.4C303.6,274.4,302.1,271.3,302.1,267.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 307,
    cy: 265.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 317.2,
    cy: 272.7,
    rx: 2.2,
    ry: 2.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape8A);
export default __webpack_public_path__ + "static/media/eyeshape_8a.b414151824c49e1da706a4acc448b29e.svg";
export { ForwardRef as ReactComponent };